var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigmouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "style=linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M9.4 11.8C12.3824 11.8 14.8 9.38234 14.8 6.4C14.8 3.41766 12.3824 1 9.4 1C6.41766 1 4 3.41766 4 6.4C4 9.38234 6.41766 11.8 9.4 11.8Z",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rec",
    d: "M1 20.8861C1 17.8564 3.45604 15.4004 6.48572 15.4004H12.3143C15.344 15.4004 17.8 17.8564 17.8 20.8861C17.8 23.1584 15.958 25.0004 13.6857 25.0004H5.11428C2.84202 25.0004 1 23.1584 1 20.8861Z",
    stroke: "#1B224C",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigmouticon);
export default __webpack_public_path__ + "static/media/sigmouticon.789e48abbaefcb271079a183c114ac02.svg";
export { ForwardRef as ReactComponent };